module.exports = __webpack_public_path__ + "img/image3.4be45fb2.jpg";